"use strict";function videoConfCall$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.videoConfCall$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.conference.videoConfCall";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"5.0.8"},_a[ddSdk_1.ENV_ENUM.android]={vs:"5.0.8"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"5.1.28"},_a)),exports.videoConfCall$=videoConfCall$,exports.default=videoConfCall$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/conference/videoConfCall.js
// module id = 928
// module chunks = 106